import type { AlertCondition } from "../../api/types";

/**
 * Human labels and threshold units for the closed set of alert conditions
 * (ADR-0030 P4-5, mirrors `alertsvc.AllConditions()` — see AlertCondition's
 * doc comment in types.ts). `thresholdLabel: null` means the condition is
 * instant and ignores `threshold` — the create/edit forms hide the
 * threshold field entirely rather than showing a number that does nothing
 * (Q-7: never a control that silently no-ops).
 */
export const CONDITION_META: Record<
  AlertCondition,
  { label: string; thresholdLabel: string | null; thresholdHint?: string }
> = {
  placement_failed: {
    label: "A service fails to run somewhere",
    thresholdLabel: null,
  },
  node_offline: {
    label: "A machine goes offline",
    thresholdLabel: "Offline for at least (seconds)",
    thresholdHint: "How long a machine must be unreachable before this fires.",
  },
  connection_unreachable: {
    label: "A required connection becomes unreachable",
    thresholdLabel: null,
  },
  cert_expiry: {
    label: "A machine's certificate is expiring",
    thresholdLabel: "Within (days)",
    thresholdHint: "Fires once the certificate's expiry falls inside this window.",
  },
};

export const CONDITION_OPTIONS: { value: AlertCondition; label: string }[] = (
  Object.keys(CONDITION_META) as AlertCondition[]
).map((value) => ({ value, label: CONDITION_META[value].label }));
